import { useState, useEffect } from "react";
import { ShieldCheck } from "lucide-react";

export default function AgeGate() {
  const [ok, setOk] = useState(true);
  useEffect(() => { setOk(localStorage.getItem("sq_age_ok") === "1"); }, []);
  if (ok) return null;
  const accept = () => { localStorage.setItem("sq_age_ok", "1"); setOk(true); };
  return (
    <div data-testid="age-gate" className="fixed inset-0 z-[100] bg-[#050810]/95 backdrop-blur-md flex items-center justify-center p-4">
      <div className="max-w-md w-full rounded-2xl border border-[#232D42] bg-[#0F1420] p-6 text-center">
        <div className="h-12 w-12 rounded-xl bg-[#00E5A3]/15 flex items-center justify-center mx-auto mb-4">
          <ShieldCheck size={24} className="text-[#00E5A3]" />
        </div>
        <h2 className="font-heading text-xl font-extrabold text-slate-100 mb-2">Before you enter</h2>
        <p className="text-sm text-slate-400 mb-5 leading-relaxed">
          SidelineIQ provides sports information for research purposes only —{" "}
          <span className="text-slate-300 font-semibold">not betting advice</span>. You must be of legal age
          (18+, or 21+ where required for sports wagering) in your jurisdiction to continue. If you or someone
          you know has a gambling problem, call <span className="text-[#00E5A3]">1-800-426-2537</span>.
        </p>
        <button data-testid="age-gate-accept" onClick={accept}
          className="w-full h-11 rounded-lg bg-[#00E5A3] hover:bg-[#00C98E] text-[#04140F] font-semibold transition-colors">
          I'm of legal age — Enter
        </button>
        <a href="https://www.google.com" data-testid="age-gate-leave"
          className="block text-xs text-slate-500 hover:text-slate-300 mt-3">Leave</a>
        <div className="mt-4 flex justify-center gap-4 text-[11px] font-mono text-slate-600">
          <a href="/terms" className="hover:text-slate-400">Terms</a>
          <a href="/privacy" className="hover:text-slate-400">Privacy</a>
        </div>
      </div>
    </div>
  );
}
